<template>
	<div class="row content">
		<div class="col-12">
			<div class="row">
				<div class="col-3"><h5>Carga Masiva de Clientes</h5></div>
				<div class="col-9 text-right">
					<b-button size="sm" variant="primary" @click="enviar" :disabled="datos.length == 0">Procesar</b-button>&nbsp;
					<b-button size="sm" variant="secondary" @click="cerrar">Cerrar</b-button>
				</div>
			</div>
			<hr style="margin-top: 10px; margin-bottom: 5px" />
			<p></p>
			<div class="row">
				<div class="col-12">
					<b-form id="cargarMasivoForm">
						<div class="row">
							<div class="col-8">
								<upload-excel type="xls" :on-success="onSuccess" :before-upload="beforeUpload" />
							</div>
						</div>
					</b-form>
				</div>
			</div>
			<p></p>
			<div v-if="error">class="row"><div class="col-12"><h5><i class="fas fa-exclamation fa-fw" /> {{ mensaje }}</h5></div></div>
			<div v-if="fin">class="row"><div class="col-12"><h5><i class="fas fa-check-double fa-fw" /> {{ mensaje }}</h5></div></div>
			<div v-if="invalidos.length > 0" class="row"><div class="col-12 text-center"><h4>Registros con error: {{ invalidos.length }} de {{ datos.length }}</h4></div></div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import moment from "moment"
	import UploadExcel from "./upload_excel.vue"
	import ValidaRut from "./ValidaRut.js"


	export default 
	{
		name: "CrearMasivo",
		components: { UploadExcel },
		props: {
			clientes: Array,
			onCerrar: Function,
		},
		data() {
			return {
				mensaje: "",
				archivo: null,
				formato: [ "last_event_type", "soporte", "sales_rep", "client_type", "client_kind", "client_id", "client_id_madre", "client_name", "client_tax_code", "billing_period", "payment_terms", "size", "sector", "starred", "city", "county", "country", "registered_users", "potential_users", "charge_code_format", "charge_code_required", "metodo_pago", "using_labels", "deal_value", "categoria", "grupo_economico", "centro_costo", "orden_compra", "desglose", "hes", "especial", "nombre_admin", "correo_admin", "telefono_admin", "telefono_admin2", "nombre_cob", "correo_cob", "telefono_cob", "telefono_cob2", "correos_fac", "giro", "client_address", "client_city", "ciudad_fac", "detalle_cc_facturacion", "collection", "vencimiento_oc", "n_oc", "recurrente" ],
				required: [ "client_id_madre", "client_name", "client_tax_code", "payment_terms", "centro_costo", "orden_compra", "desglose", "hes", "especial", "correos_fac", "giro", "client_address", "client_city", "ciudad_fac", "recurrente" ],
				error: false,
				fin: false,
				datos: [],
				invalidos: [],
				validos: [],
			}
		},
		methods: {

			beforeUpload() {

				this.error = false
				// Activamos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

				return true
			},

			onSuccess(header, data, file) {

				// Ocultamos la imagen cargando
				window.event.$emit("mostrar-cargando", false)

				if (header.join() == this.formato.join()) {

					this.datos = data
					this.procesar()
				} else {

					this.mensaje = "El formato del archivo no corresponde"
					this.error = true
				}
			},

			// Devuelve TRUE si el Client ID existe
			buscarCliente(id) {

				var flag = false
				this.clientes.forEach(function(cliente) {

					if (cliente.CLIENT_ID == id)
					{
						flag = true
						return false
					}
				})


				return flag
			},

			buscarDuplicados(id) {

				var cnt = 0
				this.datos.forEach(function(dato) {

					if (dato.CLIENT_ID == id)
						cnt++
				})


				return cnt > 1 
			},

			procesar() {

				var that = this
				this.datos.forEach(function(registro, idx) {

					if (registro.CLIENT_TAX_CODE != null && registro.CLIENT_TAX_CODE != "")
					{
						var rut = registro.CLIENT_TAX_CODE.toString().toUpperCase().replace(/[`~!@#$%^*()|+\=?;.:'",<>\{\}\[\]\\\/]/gi, '')
						
						var valido = ValidaRut(rut)
						if (!valido)
						{
							registro["MOTIVO"] = "RUT INVALIDO"
							that.invalidos.push(registro)

							return
						}

						// Validamos que los campos obligatorios tengan valor
						var seguir = true 
						for (var campo of that.required) 
						{
							if (registro[campo] == "")
								seguir = false
						}

						if (registro.RECURRENTE.toLowerCase() == "si")
						{
							if (registro.N_OC == null || registro.N_OC == "" || registro.VENCIMIENTO_OC == null || registro.VENCIMIENTO_oc == "")
								seguir = false
						}

						// Si el registro no trae todos los datos obligatorios, no se procesa y se agrega a la lista INVALIDOS
						if (!seguir) 
						{
							registro["MOTIVO"] = "FALTAN DATOS EN EL CLIENTE"
							that.invalidos.push(registro)

							return
						}

						// Si el Client ID ya existe, no se procesa y se agrega a la lista INVALIDOS
						var existe = that.buscarCliente(registro.CLIENT_ID)
						if (existe)
						{
							registro["MOTIVO"] = "CLIENTE YA EXISTE"
							that.invalidos.push(registro)

							return	
						}

						// Si el Client ID está duplicado en el archivo, no se procesa y se agrega a la lista INVALIDOS
						var duplicado = that.buscarDuplicados(registro.CLIENT_ID)
						if (duplicado)
						{
							registro["MOVITO"] = "ID DUPLICADO EN EL DOCUMENTO"
							that.invalidos.push(registro)

							return
						}

						// Cambiamos por blanco todos aquellos que tenga el valor NULL
						for (var campo in registro)
						{
							if (registro[campo] == null)
								registro[campo] = ""
						}

						registro["USUARIO_CREACION_BS"] = that.$usuario
						registro["F_CREACION_BS"] = moment().format("YYYY-MM-DD HH:mm:ss")
						registro["USUARIO_ACTUALIZACION"] = that.$usuario 
						registro["FECHA_ACTUALIZACION"] = moment().format("YYYY-MM-DD HH:mm:ss")
						registro["@timestamp "] = moment().format("YYYY-MM-DD HH:mm:ss")
						registro["estado"] = "activo"

						that.formato.forEach(function(campo) {

							if (registro[campo.toUpperCase()] == undefined)
								registro[campo.toUpperCase()] = ""
						})

						// Guardamos los registros que hayan pasado las validaciones
						that.validos.push(registro)
					}
				})
			},

			enviar() {

				var request = {
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx": "man0",
					"proceso": "newCli",
					"clientes": this.validos,
				}

				// Variable que controla si se muestra el mensaje de fin del proceso
				this.fin = false

				// mostramos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

				// Llamada a la API
				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					this.mensaje = response.data
					this.fin = true

					// ocultamos la imagen cargando
					window.event.$emit("mostrar-cargando", false)
				}).catch(ex => {

					this.mensaje = ex.message
					this.error = true

					// ocultamos la imagen cargando
					window.event.$emit("mostrar-cargando", false)
				})
			},

			cerrar() {

				if (this.onCerrar)
					this.onCerrar()
			},
		}
	}
</script>
<style scoped>

	.content {
		height: 485px;
		/*margin: 10px;*/
		border: 1px solid lightgray;
		background-color: white;
		padding: 10px 10px 10px 10px;
	}

</style>
